import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'
import { useFormContext } from 'react-hook-form'
import { Checkbox as CheckboxUi } from 'src/ui/atoms/Checkbox'
import React from 'react'

import { Error } from '../Error'
import { Width } from '../Width'
import { CheckboxField } from '@/payload-types'
import { FormLabel } from '@/ui/atoms/FormLabel'

export const Checkbox: React.FC<
  CheckboxField & {
    errors: Partial<
      FieldErrorsImpl<{
        [x: string]: any
      }>
    >
    getValues: any
    register: UseFormRegister<FieldValues>
    setValue: any
    hasError: boolean
  }
> = ({ name, defaultValue, description, errors, label, register, required, width, hasError }) => {
  const pattern = required ? /^true$/ : /^true|false$/
  const props = register(name, { required: required ?? false, pattern: pattern })
  const { setValue } = useFormContext()

  return (
    <Width width={width ?? 100}>
      <div className="flex items-start gap-2">
        <CheckboxUi
          defaultChecked={defaultValue ?? false}
          value={defaultValue ? 'true' : 'false'}
          id={name}
          {...props}
          onCheckedChange={(checked) => {
            setValue(props.name, checked)
          }}
          hasError={errors[name] ? true : false}
        />
        <FormLabel htmlFor={name} description={description}>
          {label}
        </FormLabel>
      </div>
      <div className={``}>{required && <> {errors[name] && <Error />}</>}</div>
    </Width>
  )
}
